export const formLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 18 },
}
export const tailLayout = {
  wrapperCol: { offset: 4, span: 18 },
}

export const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 },
  },
}

export const formItemLayoutWithOutLabel = {
  wrapperCol: {
    xs: { span: 24, offset: 0 },
    sm: { span: 20, offset: 4 },
  },
}

export { default as AuthForm } from './Auth'
export { default as QuestionForm } from './Question'
export { default as QuestionTemplateForm } from './QuestionTemplate'
export { default as ShelterForm } from './Shelter'
export { default as TokenForm } from './Token'
export { default as MappingForm } from './Mapping'
export { default as AdoptionApplicationForm } from './AdoptionApplication'
export { default as AdminRoleForm } from './AdminRole'
export { default as AdminUserForm } from './AdminUser'
export { default as ShelterProductForm } from './ShelterProduct'
export { default as ShelterTaxForm } from './ShelterTax'
export { default as RegisterShelterForm } from './RegisterShelter'
export { default as SpecieForm } from './Specie'
export { default as BreedForm } from './Breed'
export { default as GroupForm } from './Group'
export { default as SponsorForm } from './Sponsor'
export { default as EventForm } from './Event'
export { default as EmailTemplateFrom } from './EmailTemplate'
export { default as IntegrationForm } from './Integration'
export { default as IntegrationRegisterForm } from './Integration/Register'
export { default as KioskForm } from './Kiosk'
